import { getMessages } from '../../../../../store/constants';

export const CLASS_AFTER_SKIP_DIALOG= 'after-skip-dialog';

export const AFTER_SKIP_DIALOG_YES = getMessages().getText('after_skip_dialog.yes');
